module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "cop"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "crt"
  }, [_vm._v("This edition first published in the United States in 2007 by "), _c('br'), _vm._v("The Overlook Press, Peter Mayer Publishers, Inc.")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "crt"
  }, [_vm._v("141 Wooster Street "), _c('br'), _vm._v("New York, NY 10012 "), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.overlookpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.overlookpress.com")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "crt"
  }, [_vm._v("For bulk and special sales, please contact sales@overlookny.com")]), _vm._v(" "), _c('div', {
    staticClass: "crt-copy"
  }, [_c('div', [_c('br')]), _vm._v("Copyright © 2001 by Penny Vincenzi")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced "), _c('br'), _vm._v("or transmitted in any form or by any means, electronic or mechanical, "), _c('br'), _vm._v("including photocopy, recording, or any information storage and retrieval "), _c('br'), _vm._v("system now known or to be invented, without permission in writing from the "), _c('br'), _vm._v("publisher, except by a reviewer who wishes to quote brief passages in connection "), _c('br'), _vm._v("with a review written for inclusion in a magazine, newspaper, or broadcast.")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "crt"
  }, [_vm._v("Cataloging-in-Publication Data is available from the Library of Congress")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "crt"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "crt"
  }, [_vm._v("ISBN: 9781590207963")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57f950eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vinc_9781590207963_oeb_cop_r1.vue
// module id = 69
// module chunks = 0